import { motion } from "framer-motion";
import { Users } from "lucide-react";
import { IconContainer } from "../campaign/basic/IconContainer";
import { Button } from "../generic/Button";
import { Heading } from "../generic/Heading";

export default function EmptyState<T>({
  onPress,
}: {
  onPress: (index?: T) => void;
}) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      className="flex w-full justify-center"
    >
      <div className="flex w-sm flex-col items-center gap-6">
        <div>
          <IconContainer className="rounded-full p-3.5">
            <Users size={30} className="text-theme-active/80" />
          </IconContainer>
        </div>
        <div className="flex flex-col gap-4">
          <Heading level={3} className="text-center">
            Kontaktpersoner
          </Heading>

          <p className="text-theme-on-glass-variant text-center text-xs">
            Find leads med de rigtige kontaktpersoner. Tilføj en persona for at
            komme i gang.
          </p>
        </div>
        <div>
          <Button animate onPress={() => onPress()}>
            Tilføj persona
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
